import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import axios from "../../axios";
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Box,
  Link,
  Avatar
} from "@mui/material";
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';

function Register() {
  const [form, setForm] = useState({
    companyName: "",
    Mobile: "",
    Email:"",
    userName: "",
    password: "",
  });

  const [message, setMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    try {
      const response = await axios.post("/auth/register-company", form);

      if (response.status === 200 || response.status === 201) {
        setIsSuccess(true);
        setMessage("✅ تم إنشاء الحساب بنجاح! سيتم تحويلك لصفحة تسجيل الدخول...");
        setForm({
          companyName: "",
          Mobile: "",
          Email:"",
          userName: "",
          password: "",
        });
        
        // تحويل المستخدم لصفحة تسجيل الدخول بعد 2 ثانية
        setTimeout(() => {
             window.location.href = '/login';
        }, 2000);

      } else {
        setIsSuccess(false);
        setMessage(`❌ فشل: ${response.data}`);
      }
    } catch (error) {
      setIsSuccess(false);
      const errorMsg = error.response?.data || error.message || "خطأ في الاتصال بالسيرفر";
      setMessage(`❌ ${errorMsg}`);
    }
  };

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center',
        bgcolor: 'grey.100',
        px: 2
      }}
    >
      <Container maxWidth="xs" sx={{ p: 0 }}>
        <Paper
          elevation={4}
          sx={{
            p: { xs: 3, sm: 4 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 3,
            width: '100%',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main", width: 56, height: 56 }}>
            <AppRegistrationIcon fontSize="large" />
          </Avatar>
          <Typography component="h1" variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
            📋 تسجيل شركة جديدة
          </Typography>

          {message && (
            <Alert severity={isSuccess ? "success" : "error"} sx={{ width: "100%", mb: 2 }}>
              {message}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
            <TextField
              margin="normal"
              fullWidth
              label="اسم الشركة"
              name="companyName"
              value={form.companyName}
              onChange={handleChange}
              required
              variant="outlined"
              sx={{ mb: 2 }}
            />
            <TextField
              margin="normal"
              fullWidth
              label="رقم الجوال"
              name="Mobile"
              value={form.Mobile}
              onChange={handleChange}
              required
              variant="outlined"
              sx={{ mb: 2 }}
            />
            <TextField
              margin="normal"
              fullWidth
              label="البريد الالكتروني"
              name="Email"
              value={form.Email}
              onChange={handleChange}
              required
              variant="outlined"
              sx={{ mb: 2 }}
            />
            <TextField
              margin="normal"
              fullWidth
              label="اسم المستخدم"
              name="userName"
              value={form.userName}
              onChange={handleChange}
              required
              variant="outlined"
              sx={{ mb: 2 }}
            />
            <TextField
              margin="normal"
              fullWidth
              label="كلمة المرور"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
              variant="outlined"
              sx={{ mb: 3 }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              color="secondary"
              sx={{ 
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: 'bold',
                mb: 2,
                borderRadius: 2 
              }}
            >
              تسجيل
            </Button>

            <Box textAlign="center" sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                لديك حساب بالفعل؟{" "}
                <Link 
                  component={RouterLink} 
                  to="/login" 
                  sx={{ 
                    fontWeight: 'bold', 
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' } 
                  }}
                >
                  تسجيل الدخول
                </Link>
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default Register;
